<template>
  <section id="freelance">
    <div class="co-container-lg px-4 pt-5 text-left md:text-center">
      <h2 class="co-display-9 mb-5 text-center font-bold">
        イチからフリーランスを目指したい方
      </h2>

      <div class="flex flex-wrap justify-center">
        <!-- デザイン実践ポートフォリオ -->
        <a
          class="te-course-block rounded border border-[#dee2e6] bg-white hover:opacity-80"
          href="/course/wordpress"
        >
          <div class="te-course-title te-bg-wordpress-trans-70 relative flex flex-col justify-center text-center font-bold text-white">
            WordPress
          </div>
          <div class="te-course-caption p-2 text-left text-co-gray-700 md:p-3 lg:p-4">
            CMSを使ったオリジナルサイトを構築
          </div>
        </a>

        <!-- デザイン実践ポートフォリオ -->
        <a
          class="te-course-block rounded border border-[#dee2e6] bg-white hover:opacity-80"
          href="/course/design-portfolio"
        >
          <div class="te-course-title te-bg-design-portfolio-trans-70 relative flex flex-col justify-center text-center font-bold text-white">
            デザイン実践ポート
            <br>
            フォリオ
            <span class="te-middle-level bg-white p-1 font-normal leading-none text-co-gray-700">中級向け</span>
          </div>
          <div class="te-course-caption p-2 text-left text-co-gray-700 md:p-3 lg:p-4">
            実践を想定したバナーやLPを制作
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-course-block {
  width: calc(50% - 8px);
  margin-bottom: 20px;
  border-radius: 6px;
  @media (min-width: 576px) {
    width: calc(33% - 16px);
  }
  @media (min-width: 992px) {
    width: calc(25% - 16px);
  }
  &:nth-child(odd) {
    margin-right: 8px;
    @media (min-width: 576px) {
      margin-right: 8px;
      margin-left: 8px;
    }
  }
  &:nth-child(even) {
    margin-left: 8px;
    @media (min-width: 576px) {
      margin-right: 8px;
      margin-left: 8px;
    }
    &:last-child {
      margin: 0 0 20px 8px;
      @media (min-width: 576px) {
        margin: 0 8px 20px;
      }
    }
  }
  &:nth-child(odd):last-child {
    margin: 0 0 20px;
    @media (min-width: 576px) {
      margin: 0 8px 20px;
    }
  }
}

/* コースタイトル */
.te-course-title {
  height: 92px;
  font-size: 0.75rem;
  border-radius: 6px 6px 0 0;
  @media (min-width: 576px) {
    font-size: 0.875rem;
  }
  @media (min-width: 992px) {
    height: 120px;
    font-size: 1.125rem;
  }
}

/* コースアイコン */
.te-course-icon {
  font-size: 1.25rem;
  @media (min-width: 992px) {
    font-size: 1.5rem;
  }
}

.te-course-caption {
  font-size: 0.75rem;
  @media (min-width: 768px) {
    font-size: 0.875rem;
  }
  @media (min-width: 992px) {
    font-size: 1rem;
  }
}

.te-middle-level {
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: 0.625rem;
  border-radius: 2px;
}

.te-bg-wordpress-trans-70 {
  background: linear-gradient(
      rgba(30, 140, 190, 0.7) 0%,
      rgba(30, 140, 190, 0.7) 100%
    ),
    url('~/assets/images/Te/TeCourse/Index/WebSite/bg-webtool.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.te-bg-design-portfolio-trans-70 {
  background: linear-gradient(
      rgba(224, 154, 68, 0.7) 0%,
      rgba(224, 154, 68, 0.7) 100%
    ),
    url('~/assets/images/Te/TeCourse/Index/WebSite/bg-website.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>

